import { Tooltip } from '@material-ui/core'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import { PDFDownloadLink } from '@react-pdf/renderer'
import moment from 'moment'
import React from 'react'
import { toast } from 'react-toastify'
import { COLORES } from '../../../config/colores'
import { TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL, TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA, TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA_PROGRESS_BARS } from '../../../config/tables'
import Movimiento from '../../../models/movimiento/movimientoService'
import { MovimientoUtils } from '../../../models/movimiento/movimientoUtils'
import { pdfCustomToolbarGenerator } from '../../../models/tools/generarPdf'
import Laridae from '../../../models/tools/laridae'
import GenerarPdf from '../../Forms/SharedComponents/containers/GenerarPdf/GenerarPdf'
import { mapObjectsArrayToAllStringWithoutNulls, setShowFooter } from '../../Utils/actions'
import {
  COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL,
  COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA,
  COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA_PROGRESS_BARS,
  COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA_PROGRESS_BARS_TO_PRINT,
  COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_TO_PRINT
} from '../containers/constants'
import DetallesLineaDialog from '../containers/DetallesLineaDialog'
import DetallesSiloDialog from '../containers/DetallesSiloDialog'
import MovimientoMercaderia from '../../../models/movimiento/movimiento_mercaderia'
import { actualizarDatosMovimientoMercaderiaPendiente } from '../../Movimiento/TablasSinAsignar/movimientosMercaderia/actions/TablaMovimientosMercaderiaActions'
import LecturaValoresSilo from '../../../models/movimiento/lectura_valores_silos'
import { getCamionesTotal } from '../../Camiones/actions'

export function fetchSilosData () {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_SILOS_D3_VIEW',
      loading: true
    })
    const dataSilos = MovimientoUtils.parseDataForCuadroDeMando(await Movimiento.getMovimiento())
    dispatch({
      type: 'UPDATE_SILOS_D3_VIEW',
      loading: false,
      data: dataSilos
    })
  }
}

export function fetchCerealesPorLineaData () {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_CEREAL_POR_LINEA_D3_VIEW',
      loading: true
    })
    const cereales = MovimientoUtils.parseDataForCerealPorLineaD3View(await Movimiento.getDataForCerealPorLineaD3View())
    const totalesPorLinea = MovimientoUtils.parseDataForCerealPorLineaD3View(await Movimiento.getTotalesPorLineaD3View())
    dispatch({
      type: 'UPDATE_CEREAL_POR_LINEA_D3_VIEW',
      loading: false,
      data: { cereales, totalesPorLinea }
    })
  }
}

export function fetchCerealesPorLineaDataParaTabla () {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        title: 'Espacio por Linea',
        isLoading: true
      },
      id: TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA_PROGRESS_BARS
    })
    const cereales = MovimientoUtils.parseDataForCerealPorLineaD3View(await Movimiento.getDataForCerealPorLineaD3View())
    const customToolbarJsx = await pdfCustomToolbarGenerator(
      'Espacio por Linea',
      cereales,
      COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA_PROGRESS_BARS_TO_PRINT
    )
    const customToolbar = () => customToolbarJsx
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: false,
        columns: COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA_PROGRESS_BARS,
        data: cereales,
        extraOptions: { customToolbar, print: false }
      },
      id: TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA_PROGRESS_BARS
    })
  }
}

export function mostrarDetallesSilo (silo) {
  return async dispatch => {
    const detallesMovimientosSilo = (await Movimiento.getMovimiento()).filas.filter(siloLocal => siloLocal.nombre === silo.nombre)[0]
    dispatch({
      type: 'UPDATE_SILO_A_DETALLAR',
      detallesMovimientosSilo
    })
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'DETALLES_DE_SILO'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'DETALLES_DE_SILO',
      maxWidth: 'sm',
      content: <DetallesSiloDialog />,
      cancelCallback
    })
  }
}

export function fetchTotalEspacioSiloCereal () {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        title: 'Espacio por cereal',
        isLoading: true
      },
      id: TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL
    })
    const data = await Movimiento.getConsultaTotalEspacioSiloCereal()
    const dataTotal = await Movimiento.getConsultaTotalEspacioElevador()
    data.push({
      ...dataTotal[0],
      cereal: 'TOTAL DE EXISTENCIAS',
      cerealVariedad: ' '
    })
    const dataWithoutNulls = mapObjectsArrayToAllStringWithoutNulls(data)
    const versionLaridae = await Laridae.getUltimaVersion()
    const customToolbar = () => (
      <div>
        <PDFDownloadLink
          document={
            <GenerarPdf
              data={[dataWithoutNulls]}
              fields={COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_TO_PRINT}
              info={{
                titulo: 'Espacio por Cereal',
                subtitulo: `Fecha: ${moment().format('DD/MM/YYYY')}`,
                version: `${versionLaridae}`
              }}
            />
          }
          fileName='Espacio por Cereal.pdf'
          style={{
            textDecoration: 'none',
            marginTop: '12px',
            color: COLORES.blue.light,
            fontSize: '16px',
            fontFamily: 'sans-serif',
            borderRadius: '5px 5px 5px 5px'
          }}
        >
          {({ blob, url, loading, error }) =>
            loading ? (
              '...'
            ) : (
              <Tooltip title={'Guardar en PDF'}>
                <PictureAsPdfIcon fontSize='default' />
              </Tooltip>
            )
          }
        </PDFDownloadLink>
      </div>
    )
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: false,
        columns: COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL,
        data,
        extraOptions: { customToolbar, print: false }
      },
      id: TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL
    })
  }
}

export function fetchTotalEspacioSiloCerealPorLinea (sector) {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        title: 'Espacio por linea',
        isLoading: true
      },
      id: TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA
    })
    const data = await Movimiento.getConsultaTotalSilosLinea()
    const dataTotal = await Movimiento.getConsultaTotalEspacioElevador()
    data.push({
      ...dataTotal[0],
      linea: 'TOTAL DE EXISTENCIAS'
    })
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: false,
        columns: COLUMNS_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA,
        data
      },
      id: TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA
    })
  }
}

export function onLineaClickeada (selectedLinea) {
  return async dispatch => {
    const cereales = MovimientoUtils.parseDataForCerealPorLineaD3View(await Movimiento.getDataForCerealPorLineaD3View())
    let parsedSelectedLinea = selectedLinea.replace(/-/g, '').trim().toUpperCase()
    parsedSelectedLinea = parsedSelectedLinea[0].toLowerCase() + parsedSelectedLinea.substring(1)
    const cerealesDeLaLinea = cereales.map(cereal => ({ cereal: cereal.cereal, variedad: cereal.cerealVariedad, cantidad: cereal[parsedSelectedLinea] }))
    dispatch({
      type: 'UPDATE_LINEA_A_DETALLAR',
      linea: { linea: selectedLinea, cereales: cerealesDeLaLinea }
    })
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'DETALLES_DE_LINEA'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'DETALLES_DE_LINEA',
      maxWidth: 'sm',
      content: <DetallesLineaDialog />,
      cancelCallback
    })
  }
}

export function getTareasPendientes () {
  return dispatch => {
    MovimientoMercaderia.getTareasMovimientoPendientes()
      .then((data) => {
        dispatch({ type: 'RECEIVE_TAREAS_PENDIENTES', data })
      })
  }
}

export function getTareas () {
  return dispatch => {
    MovimientoMercaderia.getTareasMovimiento()
      .then((tareas) => {
        dispatch({ type: 'RECEIVE_TAREAS_MOVIMIENTO', tareas })
      })
  }
}

export function getTareaPorFecha (fechaRegistroTarea) {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_TAREA_POR_FECHA' })
    MovimientoMercaderia.getTareaMovimientoPorFecha(fechaRegistroTarea)
      .then(tareaInicial => {
        dispatch({ type: 'RECEIVE_TAREA_POR_FECHA', tareaInicial })
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_TAREA_POR_FECHA',
        tareaInicial: null
      }))
  }
}

export function setShowFooterDashboard (show) {
  return (dispatch) => {
    dispatch(setShowFooter(show))
  }
}

export function submitTareaMovimiento (fInicio, fFin, tarea, toneladas) {
  return (dispatch) => {
    MovimientoMercaderia.submitTareaMovimientoMercaderia(fInicio, fFin, tarea, toneladas)
      .then(async (saveStatus) => {
        if (!saveStatus.error) {
          toast.success('Tarea registrada exitosamente.')
        }
      })
  }
}

export function submitTareaMovimientoPendiente (fInicio, tarea) {
  return (dispatch) => {
    MovimientoMercaderia.submitTareaMovimientoMercaderiaPendiente(fInicio, tarea)
      .then(async (saveStatus) => {
        if (!saveStatus.error) {
          dispatch(actualizarDatosMovimientoMercaderiaPendiente())
          toast.success('Tarea registrada exitosamente.')
        }
      })
  }
}

export function lecturaSilos () {
  return (dispatch) => {
    LecturaValoresSilo.lecturaValoresSilos()
      .then((data) => {
        dispatch({ type: 'LECTURA_VALORES_SILO', data })
      })
  }
}
export function getCamionesCircuito () {
  return (dispatch) => {
    dispatch(getCamionesTotal())
  }
}
